import { colorBaseGreyWarm500, fontFamilyBodyStack, headerTinyFontWeight } from '@issuu/silkscreen';
import styled from 'styled-components';

import { breakpointWidths } from '../../constants';

export const ActionIcon = styled.div.attrs({ 'aria-hidden': true })`
    height: 1.5rem;
    width: 1.5rem;
    margin-right: 1em;
    @media (max-width: ${breakpointWidths.tinyMax}px) {
        margin-right: 0;
        margin-bottom: 1em;
    }
`;

export const ActionButton = styled.button`
    border: 0 none transparent;
    padding: 0;
    background-color: transparent;
    font-family: ${fontFamilyBodyStack};
    display: flex;
    user-select: none;
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    justify-content: start;
    align-items: center;
    color: ${props => (props.disabled ? colorBaseGreyWarm500 : 'inherit')};
    font-weight: ${headerTinyFontWeight};
    text-transform: uppercase;

    @media (max-width: ${breakpointWidths.tinyMax}px) {
        flex-direction: column;
        justify-items: center;
    }
`;
